import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {IconButton, Spinner} from "@material-tailwind/react";
import {Visibility} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {PaginationPerson} from "../../services/interface/query/paginationPerson";
import CustomDialog from "../../components/general/CustomDialog";
import CustomTable, {TypeItemTable} from "../../components/general/CustomTable";
import TermsConditions from "../terms-conditions";
import {useNavigate} from "react-router";
import {getAge} from "../../utils/personOptions";
import {useFindPersonList} from "../../services/apis/apiPerson";
import {useSearchPersonStorage} from "../../services/storage/PersonSearchStorage";

export type ModalSearchProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    value: string;
    type: string;
    loading?: boolean;
}

export default function ModalSearch({
                                        open,
                                        setOpen,
                                        value,
                                        type,
                                        loading
                                    }: ModalSearchProps) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const header = [
        '',
        t('identification'),
        t('nationality'),
        t('names'),
        t('age'),
    ];
    const {
        mutate: getPersonList,
        isPending: loadingListPerson,
        error: errorListPerson,
        data: successListPerson
    } = useFindPersonList()

    const listResponse = useSearchPersonStorage(data => data.list)
    const setListResponse = useSearchPersonStorage(data => data.setList)

    const [list, setList] = useState<PaginationPerson | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()
    const [openTermsConditions, setOpenTermsConditions] = useState(false);
    const [identification, setIdentification] = useState<string | undefined>()
    const [index, setIndex] = useState<number | undefined>()
    const history = useNavigate();

    useEffect(() => {
        if (listResponse) {
            setList(listResponse)
        }
    }, [listResponse]);

    useEffect(() => {
        if (successListPerson) {
            setList(successListPerson)
        }
    }, [successListPerson]);

    useEffect(() => {
        if (list && list.content && list.content.length > 0) {
            setListElement(list.content.map((item, index) => ({
                row: [
                    <div className={'flex justify-center'}>
                        <IconButton key={`key-${index}`} placeholder="icon-button" variant="text" color="blue"
                                    onClick={() => {
                                        if (item.identification && item.identification.length >= 13) {
                                            history(`/dashboard-ruc/${item.identification}`);
                                        } else {
                                            setIdentification(item.identification);
                                            setOpenTermsConditions(true);
                                        }
                                    }}>
                            {
                                loadingListPerson ?
                                    <Spinner className="h-4 w-4" color="blue"/> :
                                    <Visibility className="w-5 text-empColorPrimary"/>}
                        </IconButton>
                    </div>,
                    item.identification,
                    item.nationalityDescription,
                    item.names,
                    getAge(item.dateOfBirth),
                ]
            })))
        }
    }, [list, history, loadingListPerson]);

    useEffect(() => {
        if ((index || index === 0) && type && value) {
            setListResponse(undefined)
            getPersonList({type: type, identifier: value, page: index})
        }
    }, [index, getPersonList, setListResponse, type, value]);

    return (
        <>
            {openTermsConditions && <TermsConditions
                open={openTermsConditions}
                setOpen={setOpenTermsConditions}
                setOpenComponent={setOpen}
                {...{identification}}/>}
            <CustomDialog
                loading={loadingListPerson || loading}
                title={`${t('result-search')}: ${value}`}
                size={'md'}
                body={
                    <CustomTable
                        pagination={true}
                        error={errorListPerson?.message}
                        loading={loadingListPerson || loading}
                        header={header}
                        number={list?.number}
                        totalPages={list?.totalPages}
                        totalElements={list?.totalElements}
                        {...{listElement,setIndex}}
                    />
                }
                beforeClose={() => {
                    setList(undefined)
                    setListResponse(undefined);
                    setListElement(undefined);
                }}
                {...{open, setOpen}}/>
        </>
    );
}
